var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-text"},[_c('div',{staticClass:"info-text-inner"},[(_vm.icon)?_c('div',{staticClass:"icon"},[_c('font-awesome-icon',{attrs:{"icon":"info-circle"}})],1):_vm._e(),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }